
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useForm } from "@/context/FormContext";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";

interface SelectFieldProps {
  element: FormFieldType;
}

export const SelectField: React.FC<SelectFieldProps> = ({ element }) => {
  const { formData, setField } = useForm();
  
  const handleChange = (value: string) => {
    setField(element.name!, value);
  };

  if (!element.options) return null;

  return (
    <FieldWrapper element={element}>
      <Select
        value={(formData[element.name!] as string) || ""}
        onValueChange={handleChange}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder={element.placeholder || "Select an option"} />
        </SelectTrigger>
        <SelectContent>
          {element.options.map((option) => (
            <SelectItem 
              key={option.value.toString()} 
              value={option.value.toString()}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </FieldWrapper>
  );
};

export default SelectField;
